


// import React from 'react';
// import bikeImage1 from '../assets/BikeImage1.png';
// import bikeImage2 from '../assets/BikeImage2.png';
// import bikeImage3 from '../assets/BikeImage3.png';
// import bikeImage4 from '../assets/BikeImage4.png';
// import bikeImage5 from '../assets/BikeImage1.png';
// import bikeImage6 from '../assets/BikeImage2.png';
// import bikeImage7 from '../assets/BikeImage3.png';
// import bikeImage8 from '../assets/BikeImage4.png';
// import bikeImage9 from '../assets/BikeImage1.png';
// import bikeImage10 from '../assets/BikeImage2.png';
// import bikeImage11 from '../assets/BikeImage3.png';
// import bikeImage12 from '../assets/BikeImage4.png';

// const dummyData = [
//   { id: 1, name: 'Hero Glamour Xtec 125 N', cc: '125', weight: '106kg', torque: '7.73', mileage: '60KM', kmLimit: '24.0/hr', excessKm: '₹0/km', perKm: '₹7.0/km', totalAmount: '₹900', image: bikeImage1 },
//   { id: 2, name: 'Honda Shine', cc: '125', weight: '114kg', torque: '10.3Nm', mileage: '55KM', kmLimit: '30.0/hr', excessKm: '₹2/km', perKm: '₹8.0/km', totalAmount: '₹1100', image: bikeImage2 },
//   { id: 3, name: 'Bajaj Pulsar 150', cc: '150', weight: '143kg', torque: '13.25Nm', mileage: '50KM', kmLimit: '20.0/hr', excessKm: '₹1/km', perKm: '₹9.0/km', totalAmount: '₹1200', image: bikeImage3 },
//   { id: 4, name: 'TVS Apache RTR 160', cc: '160', weight: '140kg', torque: '14.12Nm', mileage: '45KM', kmLimit: '25.0/hr', excessKm: '₹3/km', perKm: '₹10.0/km', totalAmount: '₹1500', image: bikeImage4 },
//   { id: 5, name: 'Suzuki Gixxer SF', cc: '155', weight: '148kg', torque: '13.8Nm', mileage: '48KM', kmLimit: '22.0/hr', excessKm: '₹1.5/km', perKm: '₹11.0/km', totalAmount: '₹1400', image: bikeImage5 },
//   { id: 6, name: 'Yamaha FZ S', cc: '149', weight: '135kg', torque: '13.3Nm', mileage: '52KM', kmLimit: '30.0/hr', excessKm: '₹2/km', perKm: '₹12.0/km', totalAmount: '₹1600', image: bikeImage6 },
//   { id: 7, name: 'Royal Enfield Classic 350', cc: '346', weight: '195kg', torque: '28Nm', mileage: '37KM', kmLimit: '15.0/hr', excessKm: '₹5/km', perKm: '₹15.0/km', totalAmount: '₹2000', image: bikeImage7 },
//   { id: 8, name: 'KTM Duke 200', cc: '200', weight: '159kg', torque: '19.2Nm', mileage: '40KM', kmLimit: '18.0/hr', excessKm: '₹4/km', perKm: '₹14.0/km', totalAmount: '₹1800', image: bikeImage8 },
//   { id: 9, name: 'Honda CB350 H\'ness', cc: '350', weight: '181kg', torque: '30Nm', mileage: '40KM', kmLimit: '10.0/hr', excessKm: '₹6/km', perKm: '₹20.0/km', totalAmount: '₹2200', image: bikeImage9 },
//   { id: 10, name: 'TVS Raider 125', cc: '125', weight: '123kg', torque: '11.2Nm', mileage: '56KM', kmLimit: '28.0/hr', excessKm: '₹1.5/km', perKm: '₹9.0/km', totalAmount: '₹1300', image: bikeImage10 },
//   { id: 11, name: 'Yamaha MT-15', cc: '155', weight: '138kg', torque: '13.9Nm', mileage: '48KM', kmLimit: '25.0/hr', excessKm: '₹3/km', perKm: '₹11.0/km', totalAmount: '₹1500', image: bikeImage11 },
//   { id: 12, name: 'Suzuki Access 125', cc: '125', weight: '103kg', torque: '10Nm', mileage: '52KM', kmLimit: '32.0/hr', excessKm: '₹1/km', perKm: '₹8.0/km', totalAmount: '₹1000', image: bikeImage12 },
// ];

// function Products() {
//   return (
//     <div className="flex items-center justify-center min-h-screen  p-4">
//       <div className="grid gap-8 w-full max-w-[1280px]">
//         <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
//           {dummyData.map((bike) => (
//             <div
//               key={bike.id}
//               className="flex flex-col border border-gray-300 rounded-md p-4 relative h-[550px] bg-white shadow-md"
//             >
//               <select className="absolute top-3 left-3 w-[90px] h-[35px] p-0 border border-gray-400 rounded">
//                 <option value="hourly">Hourly</option>
//                 <option value="monthly">Monthly</option>
//               </select>

//               <h2 className="mt-[43px] text-md font-semibold text-center">{bike.name}</h2>

//               <img
//                 src={bike.image}
//                 alt={bike.name}
//                 className="mt-4 mx-auto"
//                 style={{ width: '240px', height: '138px' }}
//               />

//               <div className="grid grid-cols-2 gap-2 text-xs w-full mt-4">
//                 <p className="col-span-2 font-semibold text-left">Specifications</p>
//                 <p>Engine CC:</p>
//                 <p>{bike.cc}</p>
//                 <p>Weight:</p>
//                 <p>{bike.weight}</p>
//                 <p>Torque:</p>
//                 <p>{bike.torque}</p>
//                 <p>Mileage:</p>
//                 <p>{bike.mileage}</p>

//                 <p className="col-span-2 font-semibold text-left">Extras</p>
//                 <p>Km Limit:</p>
//                 <p>{bike.kmLimit}</p>
//                 <p>Excess Km:</p>
//                 <p>{bike.excessKm}</p>

//                 <p className="col-span-2 font-semibold text-left">Charges</p>
//                 <p>Per Km:</p>
//                 <p>{bike.perKm}</p>
//                 <p>Total Amount:</p>
//                 <p>{bike.totalAmount}</p>
//               </div>
              
//               <div>
//                 <button className="mt-auto bg-[#FF9630] text-white py-2 w-full rounded-md">
//                   Book Now
//                 </button>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Products;


// import React from 'react';
// import bikeImage1 from '../assets/BikeImage1.png';
// import bikeImage2 from '../assets/BikeImage2.png';
// import bikeImage3 from '../assets/BikeImage3.png';
// import bikeImage4 from '../assets/BikeImage4.png';
// import bikeImage5 from '../assets/BikeImage1.png';
// import bikeImage6 from '../assets/BikeImage2.png';
// import bikeImage7 from '../assets/BikeImage3.png';
// import bikeImage8 from '../assets/BikeImage4.png';
// import bikeImage9 from '../assets/BikeImage1.png';
// import bikeImage10 from '../assets/BikeImage2.png';
// import bikeImage11 from '../assets/BikeImage3.png';
// import bikeImage12 from '../assets/BikeImage4.png';

// const dummyData = [
//   { id: 1, name: 'Hero Glamour Xtec 125 N', cc: '125', weight: '106kg', torque: '7.73', mileage: '60KM', kmLimit: '24.0/hr', excessKm: '₹0/km', perKm: '₹7.0/km', totalAmount: '₹900', image: bikeImage1 },
//   { id: 2, name: 'Honda Shine', cc: '125', weight: '114kg', torque: '10.3Nm', mileage: '55KM', kmLimit: '30.0/hr', excessKm: '₹2/km', perKm: '₹8.0/km', totalAmount: '₹1100', image: bikeImage2 },
//   { id: 3, name: 'Bajaj Pulsar 150', cc: '150', weight: '143kg', torque: '13.25Nm', mileage: '50KM', kmLimit: '20.0/hr', excessKm: '₹1/km', perKm: '₹9.0/km', totalAmount: '₹1200', image: bikeImage3 },
//   { id: 4, name: 'TVS Apache RTR 160', cc: '160', weight: '140kg', torque: '14.12Nm', mileage: '45KM', kmLimit: '25.0/hr', excessKm: '₹3/km', perKm: '₹10.0/km', totalAmount: '₹1500', image: bikeImage4 },
//   { id: 5, name: 'Suzuki Gixxer SF', cc: '155', weight: '148kg', torque: '13.8Nm', mileage: '48KM', kmLimit: '22.0/hr', excessKm: '₹1.5/km', perKm: '₹11.0/km', totalAmount: '₹1400', image: bikeImage5 },
//   { id: 6, name: 'Yamaha FZ S', cc: '149', weight: '135kg', torque: '13.3Nm', mileage: '52KM', kmLimit: '30.0/hr', excessKm: '₹2/km', perKm: '₹12.0/km', totalAmount: '₹1600', image: bikeImage6 },
//   { id: 7, name: 'Royal Enfield Classic 350', cc: '346', weight: '195kg', torque: '28Nm', mileage: '37KM', kmLimit: '15.0/hr', excessKm: '₹5/km', perKm: '₹15.0/km', totalAmount: '₹2000', image: bikeImage7 },
//   { id: 8, name: 'KTM Duke 200', cc: '200', weight: '159kg', torque: '19.2Nm', mileage: '40KM', kmLimit: '18.0/hr', excessKm: '₹4/km', perKm: '₹14.0/km', totalAmount: '₹1800', image: bikeImage8 },
//   { id: 9, name: 'Honda CB350 H\'ness', cc: '350', weight: '181kg', torque: '30Nm', mileage: '40KM', kmLimit: '10.0/hr', excessKm: '₹6/km', perKm: '₹20.0/km', totalAmount: '₹2200', image: bikeImage9 },
//   { id: 10, name: 'TVS Raider 125', cc: '125', weight: '123kg', torque: '11.2Nm', mileage: '56KM', kmLimit: '28.0/hr', excessKm: '₹1.5/km', perKm: '₹9.0/km', totalAmount: '₹1300', image: bikeImage10 },
//   { id: 11, name: 'Yamaha MT-15', cc: '155', weight: '138kg', torque: '13.9Nm', mileage: '48KM', kmLimit: '25.0/hr', excessKm: '₹3/km', perKm: '₹11.0/km', totalAmount: '₹1500', image: bikeImage11 },
//   { id: 12, name: 'Suzuki Access 125', cc: '125', weight: '103kg', torque: '10Nm', mileage: '52KM', kmLimit: '32.0/hr', excessKm: '₹1/km', perKm: '₹8.0/km', totalAmount: '₹1000', image: bikeImage12 },
// ];

// function Products() {
//   return (
//     <div className="flex items-center justify-center min-h-screen  w-full md:p-14">
//       <div className="grid gap-8 w-full h-auto">
//         <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
//           {dummyData.map((bike) => (
//             <div
//               key={bike.id}
//               className="flex flex-col border border-gray-300 rounded-md bg-white shadow-md h-auto"
//             >
//               {/* Dropdown and Information Section */}
//               <div className="p-4 relative">
//                 <select className="absolute top-3 left-3 w-[90px] h-[35px] p-0 border border-gray-400 text-[#FF9630] rounded">
//                   <option value="hourly">Small</option>
//                   <option value="monthly">Medium</option>
//                   <option value="monthly">Large</option>
//                 </select>

//                 <h2 className="mt-[43px] text-md font-semibold text-center">{bike.name}</h2>

//                 <img
//                   src={bike.image}
//                   alt={bike.name}
//                   className="mt-4 mx-auto"
//                   style={{ width: '240px', height: '138px' }}
//                 />

//                 <div className="grid grid-cols-2 gap-2 text-xs w-full mt-4">
//                   <p className="col-span-2 font-semibold text-left">Specifications</p>
//                   <p>Engine CC:</p>
//                   <p className='text-right'>{bike.cc}</p>
//                   <p>Weight:</p>
//                   <p className='text-right'>{bike.weight}</p>
//                   <p>Torque:</p>
//                   <p className='text-right'>{bike.torque}</p>
//                   <p>Mileage:</p>
//                   <p className='text-right'>{bike.mileage}</p>

//                   <p className="col-span-2 font-semibold text-left">Extras</p>
//                   <p >Km Limit:</p>
//                   <p className='text-right'>{bike.kmLimit}</p>
//                   <p>Excess Km:</p>
//                   <p className='text-right'>{bike.excessKm}</p>

//                   <p className="col-span-2 font-semibold text-left">Charges</p>
//                   <p>Per Km:</p>
//                   <p className='text-right'>{bike.perKm}</p>
//                   <p>Total Amount:</p>
//                   <p className='text-right'>{bike.totalAmount}</p>
//                 </div>
//               </div>

//               {/* Button Section */}
//               <div className="mt-auto">
//                 <button className="bg-[#FF9630] text-white py-2 w-full rounded-md">
//                   Book Now
//                 </button>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Products;



import React, { useState } from 'react';
import bikeImage1 from '../assets/BikeImage1.png';
import bikeImage2 from '../assets/BikeImage2.png';
import bikeImage3 from '../assets/BikeImage3.png';
import bikeImage4 from '../assets/BikeImage4.png';
import bikeImage5 from '../assets/BikeImage1.png';
import bikeImage6 from '../assets/BikeImage2.png';
import bikeImage7 from '../assets/BikeImage3.png';
import bikeImage8 from '../assets/BikeImage4.png';
import bikeImage9 from '../assets/BikeImage1.png';
import bikeImage10 from '../assets/BikeImage2.png';
import bikeImage11 from '../assets/BikeImage3.png';
import bikeImage12 from '../assets/BikeImage4.png';
import NextRide from './NextRide'; // Import the NextRide component

const dummyData = [
  { id: 1, name: 'Hero Glamour Xtec 125 N', cc: '125', weight: '106kg', torque: '7.73', mileage: '60KM', kmLimit: '24.0/hr', excessKm: '₹0/km', perKm: '₹7.0/km', totalAmount: '₹900', image: bikeImage1 },
  { id: 2, name: 'Honda Shine', cc: '125', weight: '114kg', torque: '10.3Nm', mileage: '55KM', kmLimit: '30.0/hr', excessKm: '₹2/km', perKm: '₹8.0/km', totalAmount: '₹1100', image: bikeImage2 },
  { id: 3, name: 'Bajaj Pulsar 150', cc: '150', weight: '143kg', torque: '13.25Nm', mileage: '50KM', kmLimit: '20.0/hr', excessKm: '₹1/km', perKm: '₹9.0/km', totalAmount: '₹1200', image: bikeImage3 },
  { id: 4, name: 'TVS Apache RTR 160', cc: '160', weight: '140kg', torque: '14.12Nm', mileage: '45KM', kmLimit: '25.0/hr', excessKm: '₹3/km', perKm: '₹10.0/km', totalAmount: '₹1500', image: bikeImage4 },
  { id: 5, name: 'Suzuki Gixxer SF', cc: '155', weight: '148kg', torque: '13.8Nm', mileage: '48KM', kmLimit: '22.0/hr', excessKm: '₹1.5/km', perKm: '₹11.0/km', totalAmount: '₹1400', image: bikeImage5 },
  { id: 6, name: 'Yamaha FZ S', cc: '149', weight: '135kg', torque: '13.3Nm', mileage: '52KM', kmLimit: '30.0/hr', excessKm: '₹2/km', perKm: '₹12.0/km', totalAmount: '₹1600', image: bikeImage6 },
  { id: 7, name: 'Royal Enfield Classic 350', cc: '346', weight: '195kg', torque: '28Nm', mileage: '37KM', kmLimit: '15.0/hr', excessKm: '₹5/km', perKm: '₹15.0/km', totalAmount: '₹2000', image: bikeImage7 },
  { id: 8, name: 'KTM Duke 200', cc: '200', weight: '159kg', torque: '19.2Nm', mileage: '40KM', kmLimit: '18.0/hr', excessKm: '₹4/km', perKm: '₹14.0/km', totalAmount: '₹1800', image: bikeImage8 },
  { id: 9, name: 'Honda CB350 H\'ness', cc: '350', weight: '181kg', torque: '30Nm', mileage: '40KM', kmLimit: '10.0/hr', excessKm: '₹6/km', perKm: '₹20.0/km', totalAmount: '₹2200', image: bikeImage9 },
  { id: 10, name: 'TVS Raider 125', cc: '125', weight: '123kg', torque: '11.2Nm', mileage: '56KM', kmLimit: '28.0/hr', excessKm: '₹1.5/km', perKm: '₹9.0/km', totalAmount: '₹1300', image: bikeImage10 },
  { id: 11, name: 'Yamaha MT-15', cc: '155', weight: '138kg', torque: '13.9Nm', mileage: '48KM', kmLimit: '25.0/hr', excessKm: '₹3/km', perKm: '₹11.0/km', totalAmount: '₹1500', image: bikeImage11 },
  { id: 12, name: 'Suzuki Access 125', cc: '125', weight: '103kg', torque: '10Nm', mileage: '52KM', kmLimit: '32.0/hr', excessKm: '₹1/km', perKm: '₹8.0/km', totalAmount: '₹1000', image: bikeImage12 },
];

function Products() {

  const [isNextRideOpen, setIsNextRideOpen] = useState(false);

  const handleOpenNextRide = () => {
    setIsNextRideOpen(true); // Open the modal
  };

  const handleCloseNextRide = () => {
    setIsNextRideOpen(false); // Close the modal
  };

  return (
    <div className="flex items-center justify-center min-h-screen  w-full  p-4 md:p-14">
      <div className="grid gap-8 w-full h-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {dummyData.map((bike) => (
            <div
              key={bike.id}
              className="flex flex-col border border-gray-300 rounded-md bg-white  h-auto"
            >
              {/* Dropdown and Information Section */}
              <div className="p-4 relative">
                <select className="absolute top-3 left-3 w-[90px] h-[35px] p-0  border border-gray-400 text-[#FF9630] rounded">
                  <option value="hourly">Small</option>
                  <option value="monthly">Medium</option>
                  <option value="monthly">Large</option>
                </select>

                <h2 className="mt-[43px] text-md font-semibold text-center">{bike.name}</h2>

                <img
                  src={bike.image}
                  alt={bike.name}
                  className="mt-4 mx-auto"
                  style={{ width: '240px', height: '138px' }}
                />

                <div className="grid grid-cols-2 gap-2 text-xs w-full mt-4">
                  <p className="col-span-2 font-semibold text-left">Specifications</p>
                  <p>Engine CC:</p>
                  <p className='text-right'>{bike.cc}</p>
                  <p>Weight:</p>
                  <p className='text-right'>{bike.weight}</p>
                  <p>Torque:</p>
                  <p className='text-right'>{bike.torque}</p>
                  <p>Mileage:</p>
                  <p className='text-right'>{bike.mileage}</p>

                  <p className="col-span-2 font-semibold text-left">Extras</p>
                  <p >Km Limit:</p>
                  <p className='text-right'>{bike.kmLimit}</p>
                  <p>Excess Km:</p>
                  <p className='text-right'>{bike.excessKm}</p>

                  <p className="col-span-2 font-semibold text-left">Charges</p>
                  <p>Per Km:</p>
                  <p className='text-right'>{bike.perKm}</p>
                  <p>Total Amount:</p>
                  <p className='text-right'>{bike.totalAmount}</p>
                </div>
              </div>

              {/* Button Section */}
              <div className="mt-auto">
                <button
                  className="bg-[#FF9630] text-white py-2 w-full rounded-md"
                  onClick={handleOpenNextRide} // Trigger the modal
                >
                  Book Now
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
      {isNextRideOpen && <NextRide onClose={handleCloseNextRide} />}
    </div>
  );
}

export default Products;
